<form class="sgt-usuario-permissao-analise-mercado" #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Análises de Mercado
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso no lançamento das Análises de Mercado</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeGerenciarRevisoesAnalisesMercado" name="podeGerenciarRevisoesAnalisesMercado" id="podeGerenciarRevisoesAnalisesMercado">
                    <label class="custom-control-label" for="podeGerenciarRevisoesAnalisesMercado">Gerenciar Revisões</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção para permitir o usuário aprovar e reabrir revisões das Análises de Mercado</p>
            </li>
        </ul>                               
    </div>
</form>